import React from "react";
import { Typography, makeStyles } from "@material-ui/core";
import { COLORS } from "../../styles/constants";

const useStyles = makeStyles(() => ({
  container: {
    position: 'fixed',
    top: '0',
    left: '0',
    right: '0',
    bottom: '0',
    zIndex: '99999',
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '0 40px',
    '& h4': {
      color: COLORS.DARKGREY,
    }
  },
  messageWrapper: {
    maxWidth: '295px',
  }
}));

export default function MobileMessage() {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <div className={classes.messageWrapper}>
        <Typography variant="h2">Sorry!</Typography>
        <Typography variant="h4">But to fully experience utility recovery calculator please use your PC or a laptop.</Typography>
      </div>
    </div>
  )
}